import { gql } from 'types/__generated__/gql';

const KEY_ACTIVITIES_COMPLETED_REPORT_ASYNC_QUERY = gql(/* GraphQL */ `
  query keyActivitiesCompletedReportAsync(
    $where: KeyReportWhereInput!
    $dateRange: DateRangeInput!
  ) {
    keyActivitiesCompletedReportAsync(where: $where, dateRange: $dateRange) {
      id
      error
      result {
        curriculumActivitiesCompleted {
          productCurriculumCode
          activitiesCompletedCount
        }
        totalActivitiesCompletedCount
      }
    }
  }
`);

export default KEY_ACTIVITIES_COMPLETED_REPORT_ASYNC_QUERY;
